define([
    'text!product-detail/component/scene-list-new.html',
    'product-detail/mixin/product',
    'product-detail/component/swiper-products',

    'css!product-detail/component/scene-list-new.css'
], function(
    tpl,
    ProductMixin,
    SwiperProducts
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        components: {
            SwiperProducts: SwiperProducts
        },
        computed: {
            scenes: function(){
                return this.spuExtraBase.sceneData || [];
            },
            isRender: function(){
                return this.moduleConfig.scene && this.scenes.length;
            },
            featureData: function(){
                return this.selectedSkuExtra.featureData || {};
            },
            mainImage: function(){
                return this.featureData.mainImage || '';
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        methods: {
            getImageWidth: function(type){
                switch(parseInt(type)){
                    case 1:
                        return '100%';
                    case 2:
                        return '80%';
                    default:
                        return '100%';
                }
            }
        },
        mounted: function(){
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/scene-list-new.js
// module id = 310
// module chunks = 0